import React from 'react'

function Input(props) {
  const { type = 'text', placeholder = '', className = '', name, required = false } = props

  return (
    <input className={`input ${className}`} type={type} name={name} placeholder={placeholder} required={required} />
  )
}

export default Input
